import useCareerReviewService from './careerReviewService';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { FormShowTemplate } from 'framework/form';
import CareerReviewContent from './CareerReviewContent';
import useEmployeeCareerNextReviewDateService from '../shared/employeeCareerNextReviewDateService';
import { Box } from '@mui/material';
import CareerSectionTitle from '../../shared/CareerSectionTitle';
import { useShowContext } from 'framework/show';
import { isPolishContractorByEmployeeType } from 'domain/shared/employee';

const CareerDevelopmentReviewSection = () => {
  const employeeId = useEmployeeId() || '';
  const { update } = useEmployeeCareerNextReviewDateService();
  const { getCareerReviewData } = useCareerReviewService();
  const { data } = useShowContext();
  const currentEmployee = {
    employeeType: data?.getValueBySource?.('employeeType'),
    officeId: data?.getValueBySource?.('officeId'),
    businessRegistrationCountry: data?.getValueBySource?.('businessRegistrationCountry'),
  };
  const isPolishContractor = isPolishContractorByEmployeeType(currentEmployee);

  return (
    <Box position="relative">
      <CareerSectionTitle title={isPolishContractor ? 'Next performance evaluation' : 'Next career review'} />

      <FormShowTemplate
        getDataFunc={() => getCareerReviewData(employeeId)}
        submitFormFunc={update}
        getValidationSchemaFunc={async () => ({
          nextReviewDate: {
            type: 'string',
            required: true,
          },
        })}
        afterSubmit={{
          message: 'Worker information has been successfully updated.',
        }}
        messageContext="empoyeeCareer"
        isSmallLoader
      >
        <CareerReviewContent />
      </FormShowTemplate>
    </Box>
  );
};

export default CareerDevelopmentReviewSection;
